import { Box, Divider, Skeleton } from '@mui/material';
import Theme from '../../Themes/main.theme';

interface IDetailsOASkeleton {
  length: number
  }
  
const DetailsOASkeleton = ({length}: IDetailsOASkeleton) => {
  return (
    <>         
      <Box display='flex' justifyContent='flex-start'
        flexDirection='column' m={2}>
        <Skeleton width='100%' height='50px'
          sx={{ mt: 2 }} />
        <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/> 
        {[...Array(length)].map((_, key) => {
          return (
            <>
              <Box key={key} >
                <Skeleton variant='rectangular'
                  width='100%'
                  height='200px'
                  sx={{ borderRadius: '20px', mt: 5}}/>
              </Box>
            </>
          );
        })
        }  
      </Box>
    </>
  );
};

export default DetailsOASkeleton;